import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface ReconciliationModalProps {
  open: boolean;
  entityId: string;
  onEntityIdChange: (value: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

const ReconciliationModal = ({
  open,
  entityId,
  onEntityIdChange,
  onConfirm,
  onCancel,
}: ReconciliationModalProps) => {
  return (
    <Dialog open={open} onOpenChange={(open) => !open && onCancel()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Reconcile Transaction</DialogTitle>
          <DialogDescription>
            Enter the entity ID to reconcile this transaction.
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <Input
            placeholder="Entity ID"
            value={entityId}
            onChange={(e) => onEntityIdChange(e.target.value)}
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={!entityId.trim()}>
            OK
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ReconciliationModal;
